import { deleteList as deleteListRequest } from '@vlabs/api/luna-api/client';

import type { ListId } from '@vlabs/api/luna-api/model';
import {
  deleteAllCardsFromList,
  detachAllCardsFromList,
  detachAllFacesFromList,
} from '../requests';
import type { DeleteListsAction } from '../types';

async function deleteListContent(listId: string): Promise<void> {
  await deleteAllCardsFromList(listId);
}

async function detachListContent(listId: string): Promise<void> {
  await Promise.all([
    detachAllCardsFromList(listId),
    detachAllFacesFromList(listId),
  ]);
}

export interface DeleteListsProps {
  listIds: ListId[];
  action: DeleteListsAction;
}

export async function deleteLists({
  listIds,
  action,
}: DeleteListsProps): Promise<void> {
  await listIds.reduce(async (previousPromise, listId) => {
    await previousPromise;

    if (action === 'delete_content') {
      await deleteListContent(listId);
      await deleteListRequest(listId, { with_faces: 1 });
    } else {
      await detachListContent(listId);
      await deleteListRequest(listId, { with_faces: 0 });
    }
  }, Promise.resolve());
}
